<template lang="pug">
.document
  .document__content
    .document__title
      a(:target="result.openInNewWindow ? '_blank' : false",
        :href="result.url",
        :aria-label="ariaLabel"
      ) {{ result.title }}
    .document__meta
      span.document__meta-item.document__metadata(v-if="result.metadata1") {{ result.metadata1 }}
      span.document__meta-item.document__metadata(v-if="result.metadata2") {{ result.name }}
      span.document__meta-item.document__metadata(v-if="result.itemDate") {{ result.itemDateFormatted }}
    p.document__summary {{ result.summary }}
    a.document__cta(:href="result.url") Read More
      i.ico-outline-arrow_forward
</template>

<script>
import {mapGetters} from "vuex";

export default {
  name: "SearchResultDocument",
  props: ["result"],
  computed: {
    ...mapGetters(["settings"]),
    ariaLabel() {
      return this.result.title ? "Click to go to " + this.result.title : '';
    },
  },
};
</script>

<style lang="scss" scoped>
.document {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 1.25rem;
  width: 100%;
  margin: 1rem 0 0;
  padding: 0 0 1rem;
  border-bottom: 1px solid $lightGray;
  &:last-child {
    border-bottom: none;
  }
  @include mq(md) {
    flex-direction: row;
    align-items: center;
  }
  &__img {
    position: relative;
    width: 100%;
    height: auto;
    @include mq(md) {
      flex: 1 0 12.5rem;
      max-width: 12.5rem;
    }
    @include mq(lg) {
      flex: 1 0 18.125rem;
      max-width: 18.125rem;
    }
    &::after {
      content: '';
      display: block;
      padding-bottom: 56.25%;
      @include mq(md) {
        padding-bottom: 100%;
      }
      @include mq(lg) {
        padding-bottom: 75%;
      }
    }
    img {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      width: 100%;
      height: 100%;
      object-fit: cover;
    }

    & + .document__content {
      @include mq(sm) {
        flex: 0 0 calc(100% - 11.25rem - 1.25rem);
      }
      @include mq(md) {
        flex: 0 0 calc(100% - 12.5rem - 1.25rem) 
      }
      @include mq(lg) {
        flex: 0 0 calc(100% - 18.125rem - 1.25rem) 
      }
    }
  }

  &__content {
    flex: 0 0 100%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    gap: 1rem;
    @include mq(md) {
      flex: 0 1 auto;
    }
  }

  &__title {
    line-height: 1.25;
    padding: 0;
    margin: 0;
    font-size: 1.125rem;
    font-weight: 400;
    text-transform: uppercase;
    a {
      color: $black;
      cursor: pointer;
    }
    p {
      margin-bottom: 0;
    }
  }

  &__meta {
    display: flex;
    margin: 0 0 -0.5rem;
    font-size: 0.875rem;
    flex-wrap: wrap;
  }

  &__meta-item {
    display: flex;
    align-items: center;
    margin-bottom: 0.5rem;
    color: $lightBlack;
    font-size: 0.875rem;
    text-transform: uppercase;
    &:not(:last-child) {
      &::after {
        content: "|";
        margin: 0 0.5rem;
        pointer-events: none;
        color: $gray;
      }
    }
    * {
      margin: 0 0.25rem;
      &:first-child {
        margin-left: 0;
      }
    }
  }

  &__summary {
    font-size: 0.875rem;
    line-height: 1.5rem;
    margin: 0;
  }

  &__cta {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 0.875rem;
    font-weight: 400;
    text-transform: uppercase;
    &:hover {
      text-decoration: none;
      i {
        transform: translateX(0.3125rem);
      }
    }
    i {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-left: 0.3125rem;
      transform: translateX(0);
      transition: 0.24s ease;
    }
  }
}
</style>